// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-center {\n  display: grid;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}", ""]);
// Exports
module.exports = exports;
